// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ezMenu-main {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  /* Var --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* Var --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  /* Var --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-top-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-menu.css"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iDAAA;EACA,wCAAA;EACA,gDAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AACJ","sourcesContent":[".ezMenu-main {\n    padding: 4px;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    /* Var --ezClockerSilver defined in ez-body.css */\n    background-color: var(--ezClockerSilver);\n    /* Var --ezClockerBlack defined in ez-body.css */\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    border-style: solid;\n    /* Var --ezClockerGray defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-top-width: 0;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
